"use client";

import Image from "next/image";
import { GRID_CLASSES } from "@/libs/grid/grid";

const partners = [
  { name: "Ebara", src: "/images/partners/ebara.png" },
  { name: "Lister", src: "/images/partners/lister.png" },
  { name: "Perkins", src: "/images/partners/perkins.png" },
  { name: "Ebara 2", src: "/images/partners/ebara.png" },
  { name: "Lister 2", src: "/images/partners/lister.png" },
  { name: "Perkins 2", src: "/images/partners/perkins.png" },
  { name: "Ebara 3", src: "/images/partners/ebara.png" },
  { name: "Lister 3", src: "/images/partners/lister.png" },
];

export default function TrustedBrands() {
  return (
    <section className="flex flex-col bg-black w-full">
      <div className="border-y border-white/60 py-4 md:py-10 text-white w-full">
        <div className={`justify-items-center grid ${GRID_CLASSES}`}>
          <h3 className="col-span-6 md:col-span-12 text-center text-xl md:text-3xl max-w-[18ch] lg:max-w-full font-semibold">
            Trusted Equipment From Leading Brands
          </h3>
        </div>
      </div>

      <div className="w-full relative py-8 md:py-2 overflow-hidden">
        {/* Left fade */}
        <div
          className="absolute left-0 top-0 h-full w-20 md:w-40 z-10 pointer-events-none"
          style={{
            background: "linear-gradient(to right, #000000, transparent)",
          }}
        />

        {/* Right fade */}
        <div
          className="absolute right-0 top-0 h-full w-20 md:w-40 z-10 pointer-events-none"
          style={{
            background: "linear-gradient(to left, #000000, transparent)",
          }}
        />

        <div className="flex w-max animate-marquee">
          {[...partners, ...partners].map((partner, i) => (
            <div
              key={i}
              className="group relative flex items-center justify-center h-20 w-32 md:h-24 md:w-40 mx-4 shrink-0 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative h-full w-full">
                <Image
                  src={partner.src}
                  alt={partner.name}
                  fill
                  className="object-contain"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}